import React, {useEffect} from 'react'
import Persons from './Persons'

export default function Defendants(props){
    return(
        <div className='p-0' style={{fontFamily: 'Roboto'}}>
            <Persons customers={true}></Persons>
        </div>
    )
}